/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ListOrganizationsResponseMeta } from './ListOrganizationsResponseMeta';
import {
    ListOrganizationsResponseMetaFromJSON,
    ListOrganizationsResponseMetaFromJSONTyped,
    ListOrganizationsResponseMetaToJSON,
    ListOrganizationsResponseMetaToJSONTyped,
} from './ListOrganizationsResponseMeta';
import type { Property } from './Property';
import {
    PropertyFromJSON,
    PropertyFromJSONTyped,
    PropertyToJSON,
    PropertyToJSONTyped,
} from './Property';

/**
 * 
 * @export
 * @interface ListPropertiesResponse
 */
export interface ListPropertiesResponse {
    /**
     * 
     * @type {Array<Property>}
     * @memberof ListPropertiesResponse
     */
    properties: Array<Property>;
    /**
     * 
     * @type {ListOrganizationsResponseMeta}
     * @memberof ListPropertiesResponse
     */
    meta: ListOrganizationsResponseMeta;
}

/**
 * Check if a given object implements the ListPropertiesResponse interface.
 */
export function instanceOfListPropertiesResponse(value: object): value is ListPropertiesResponse {
    if (!('properties' in value) || value['properties'] === undefined) return false;
    if (!('meta' in value) || value['meta'] === undefined) return false;
    return true;
}

export function ListPropertiesResponseFromJSON(json: any): ListPropertiesResponse {
    return ListPropertiesResponseFromJSONTyped(json, false);
}

export function ListPropertiesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListPropertiesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'properties': ((json['properties'] as Array<any>).map(PropertyFromJSON)),
        'meta': ListOrganizationsResponseMetaFromJSON(json['meta']),
    };
}

export function ListPropertiesResponseToJSON(json: any): ListPropertiesResponse {
    return ListPropertiesResponseToJSONTyped(json, false);
}

export function ListPropertiesResponseToJSONTyped(value?: ListPropertiesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'properties': ((value['properties'] as Array<any>).map(PropertyToJSON)),
        'meta': ListOrganizationsResponseMetaToJSON(value['meta']),
    };
}

